import { render, staticRenderFns } from "./DataSummary.vue?vue&type=template&id=461a353a"
import script from "./DataSummary.vue?vue&type=script&lang=js"
export * from "./DataSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports